import { RouteConfig } from 'vue-router'
import { RouterPath } from '@/enums/router-path.enum'

export default (): Array < RouteConfig > => {
  return [
    {
      path: RouterPath.ECOMMERCE,
      component: () => import('./components/pages/page-ecommerce/page-ecommerce-home').then(m => m.default)
    },
    {
      path: RouterPath.ECOMMERCE_GENERIC,
      component: () => import('./components/pages/page-ecommerce-generic').then(m => m.default)
    },
    {
      path: RouterPath.SITE_APP_DETAIL,
      component: () => import('./components/pages/page-ecommerce-performance/components/pages/page-ecommerce-performance').then(m => m.default)
    },
  ]
}
